/**
 * @author jzhu
 * 2020-04-16
 * 考试模版查看
 */
import React from 'react'
import { connect } from 'dva'
import moment from 'moment'
import { modelUtils } from '../../../../utils'
import { component_tool, framework_tool, utils_tool } from '../../../../tool'

import {
  ChapterLook,
} from '@/containers/online'

let {
  WizCard,
  WizRow,
  WizCol,
  WizCollapse,
} = component_tool
let { WizContainer } = framework_tool
let { Session } = utils_tool


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/examTemplate/examTemplateLook') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateDetailInfo', record)
      } else {
        record = Session.get('examTemplateDetailInfo') || {}
      }
    }
  }
  return record
}

class ExamTemplateLook extends WizContainer {
  componentName = 'examTemplateLook'

  constructor(props) {
    super(props)
    let record = getParamRecord(props.history)
    this.state = {
      record: record,
      chapterRecord: {},
      data: []
    }
  }

  //题目类型对应
  _getValue(type, key) {
    const values = {
      type: {
        0: '单选题',
        1: '多选题',
        2: '判断题',
        3: '填空题',
        4: '主观题',
        6: '文件上传题',
        7: '排序题',
      },
      difficulty: {
        0: '低',
        1: '中',
        2: '高',
      },
      chapter: {
        0: '综合',
        1: '固定',
        2: '随机',
      },
      examType: {
        '0':'独立考试',
        '1':'课程考试',
        '2':'练习考试',
      }
    }
    return values[type][key]
  }

  propsAndStateOnChange = {
    chapterInfo: this._chapterInfo.bind(this),
  }

  _chapterInfo(nextProps, nextState) {
    let chapterInfo = nextProps['chapterInfo']
    if (chapterInfo && chapterInfo['success']) {
      let data = []
      if (chapterInfo['data'] && chapterInfo['data'] instanceof Array) {
        chapterInfo['data'].forEach((value, index) => {
          value['order'] = value['id']
          value['badge'] = this._getValue('chapter', value['type'])
          value['title'] = value['title']
          value['score'] = value['score']
          value['order'] = index
          if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
            value['questionTabelForm'].forEach((tabel, key) => {
              tabel['typeChar'] = this._getValue('type', tabel['type'])
              tabel['order'] = key
            })
          }
          if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
            value['categoryTabelForm'].forEach((categoryTabel, key) => {
              let categoryIds = categoryTabel['categoryIds']
              let categoryNames = categoryTabel['categoryNames']
              let ownCactegoryInfo = [{
                key: categoryIds,
                title: categoryNames,
                label: categoryNames,
                value: categoryIds
              }]
              categoryTabel['questionCategory'] = ownCactegoryInfo
              categoryTabel['questionCategoryTitle'] = categoryNames
              categoryTabel['difficultyTitle'] = this._getValue('difficulty', categoryTabel['difficulty'])
              categoryTabel['typeTitle'] = this._getValue('type', categoryTabel['type'])
              categoryTabel['order'] = key

            })
          }
        })
      }

      this.setState({
        data: chapterInfo['data'],
      })

    }
    return false
  }

  _componentDidMount = () => {
    const { record } = this.state

    this.doActions([
      {
        path: 'examTemplate/chapterInfo',
        payload: {
          key: 'examTemplateLook',
          apiParams: {
            id: record.id
          }
        }
      },
    ])
    const arr = []
    this.setState({
      data: arr
    })
  }


  _booleanConvert(key) {
    return key ? '是' : '否'
  }

  _timeConvret(time) {
    if (time != null && time != undefined) {
      return moment(time).format('YYYY-MM-DD HH:mm')
    } else {
      return ''
    }
  }


  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className='administrationScope-row-item'>
        <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
        <WizCol span={6}>{lv}</WizCol>
        <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
        <WizCol span={9}>{rv}</WizCol>
      </WizRow>
    )
  }


  _render() {
    const { record, data, chapterRecord } = this.state
    let { examTemplateLoading } = this.props
    if (record.totalScore && record.totalScore < 0) {
      record.totalScore = 0
    }
    let examTypeNames =''
    if (record && Array.isArray(record.examTypes) && record.examTypes) {
      examTypeNames = record.examTypes.map(et => 
        this._getValue('examType',et)
      ).join('、')
    }
    return (
      <>
        <WizCard>
          <WizCollapse className='administrationScope-collapse'
            expandIconPosition='right'
            defaultActiveKey={[0]}
          >
            <WizCollapse.Panel key={0} header={'考试信息'} className='panel-item'>
              {this._renderContentRow('考试模版名称', record.title, '考试类型', examTypeNames)}
              {this._renderContentRow('状态', record.state === 1 ? '有效' : '无效', '考试分类', record['categoryType'])}
              {this._renderContentRow('考试时长', `${record.limitMinutes}分钟`, '总分/通过分数', `${record['totalScore'] || 0}/${record['passScore'] || 0}`)}
              {this._renderContentRow('允许重复考试', `${record['count'] || 0}次`, '试卷题序打乱', this._booleanConvert(record.shuffle))}
              <WizRow className='administrationScope-row-item'>
                <WizCol className='col-item' span={3} offset={1}>{'切屏限制次数：'}</WizCol>
                <WizCol span={6}>{record?.['cuttingScreenNum'] ? `${record?.['cuttingScreenNum'] || 0}次` : '无限制'}</WizCol>
                <WizCol className='col-item' span={3} offset={2}>{''}</WizCol>
                <WizCol span={9}></WizCol>
              </WizRow>

              {/*<WizRow className='administrationScope-row-item'>*/}
              {/*  <WizCol className='col-item' span={3} offset={1}>{'身份验证：'}</WizCol>*/}
              {/*  <WizCol span={6}>{this._booleanConvert(record.face)}</WizCol>*/}
              {/*  <WizCol className='col-item' span={3} offset={2}>{''}</WizCol>*/}
              {/*  <WizCol span={9}></WizCol>*/}
              {/*</WizRow>*/}
            </WizCollapse.Panel>
            <WizCollapse.Panel key={1} header={'考试章节'} className='panel-item'>
              <ChapterLook data={data} record={chapterRecord} examLoading={examTemplateLoading} />
            </WizCollapse.Panel>
          </WizCollapse>
        </WizCard>

      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { examTemplate } = state
  const chapterInfo = modelUtils.getModelEntity(examTemplate, 'examTemplateLook')
  const load = modelUtils.getLoadingState(state, 'examTemplate')
  return {
    chapterInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ExamTemplateLook)
